import { UsuarioI } from "interfaces/Usuario";
import { ReactNode } from "react";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: UsuarioI;
  renderActions?: (elemento: UsuarioI) => ReactNode;
}

const cutText = (text: string | undefined, maxLength: number) => {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const UsuariosRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`NotificacionesTable-${elemento.id}`}>
        <td>
          {elemento.nombre} {elemento.apellido}
        </td>
        <td>{elemento.email}</td>
        <td>{elemento.rol.nombre}</td>
        <td>{formatDate.stringDate(elemento.createdAt)}</td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
